import { cx } from "@/components/ui/cx"

/** A labelled row of filter chips, the idiom every admin index page shares. */
export function FilterRow({
  label,
  children,
}: {
  label: string
  children: React.ReactNode
}) {
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <span className="eyebrow mr-1.5">{label}</span>
      {children}
    </div>
  )
}

/*
 * Scope chips: an applied one takes the half-step (bg.active, stone.100 at 50%
 * over paper) in ink, with the desk's stone.300 as its edge; the rest are
 * quiet and hover to the same half-step.
 */
export function FilterChip({
  active,
  onClick,
  children,
}: {
  active: boolean
  onClick: () => void
  children: React.ReactNode
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={cx(
        "h-7 rounded-full px-3 text-xs font-medium transition-colors duration-(--duration-snap)",
        active
          ? "bg-active text-primary ring-1 ring-(--color-bg-tertiary) ring-inset"
          : "text-tertiary hover:bg-active hover:text-primary",
      )}
    >
      {children}
    </button>
  )
}
